import { render, staticRenderFns } from "./OrderDetailsForm.vue?vue&type=template&id=487b4cb6&scoped=true&"
import script from "./OrderDetailsForm.vue?vue&type=script&lang=ts&"
export * from "./OrderDetailsForm.vue?vue&type=script&lang=ts&"
import style0 from "./OrderDetailsForm.vue?vue&type=style&index=0&id=487b4cb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_4b1a8e7b0323687afa589ac3884e675c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487b4cb6",
  null
  
)

export default component.exports